import { createSelector } from "reselect";
import { orderBy } from "lodash";
const visitsSelector = ({ visitDetails }) => visitDetails;

export const getPastVisits = createSelector(
  visitsSelector,
  ({ visitsPastReducer }) =>
    orderBy(visitsPastReducer.data, ["visitDate"], ["desc"])
);
